import type { JSX, ReactNode } from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

import crvSystemsMark from '../assets/branding/crv-systems-mark.svg';

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

export function AuthShell({ title, subtitle, children }: AuthShellProps): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        py: 4,
        bgcolor: 'background.default',
      }}
    >
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: 480,
          boxShadow: '0 24px 72px rgba(17, 27, 23, 0.08)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Stack spacing={3}>
            <Stack spacing={1.5} alignItems="flex-start">
              <Stack direction="row" spacing={1.25} alignItems="center">
                <Box component="img" src={crvSystemsMark} alt="" sx={{ width: 40, height: 40 }} />
                <Stack spacing={0}>
                  <Typography variant="h6" color="primary" sx={{ lineHeight: 1.15 }}>
                    CRV Systems
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Web workspace
                  </Typography>
                </Stack>
              </Stack>
              <Stack spacing={0.5}>
                <Typography variant="h5">{title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              </Stack>
            </Stack>
            {children}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
